import React, { useCallback, useMemo } from 'react';
import { Dropdown } from '@cognitiv/cyprus-ui';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppSelector } from 'ducks/hooks';
import { selectProject } from 'ducks/project/selectors';
import { selectProjects } from 'ducks/projects/selectors';
import { UnionFromArray } from 'ducks/types/type-helpers';
import { useLocation, useNavigate } from 'react-router-dom';
import { getEntityWidth } from 'utils/helpers';

import cn from 'components/breadcrumbs/Breadcrumbs.module.scss';

export const BatchDefinition = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const project = useAppSelector(selectProject);
  const projects = useAppSelector(selectProjects);

  const selectDropdownProject = useCallback(
    (item: UnionFromArray<typeof projects>) => {
      navigate(`/projects/${item.project_id}/batch_definitions/all/${search}`);
    },
    [navigate, search],
  );

  const project_name = `${project.project_name ?? 'Projects'}`;
  const project_width = useMemo(() => getEntityWidth(project_name), [project_name]);
  return (
    <>
      <div className={cn.items}>
        <div className={cn.dropdownWrapper} style={{ width: project_width }}>
          <Dropdown
            scroll_height={300}
            show_icon
            options={projects}
            value={project_name}
            placeholder="Projects"
            option_key="project_name"
            onSelect={selectDropdownProject}
            width={project_width}
            select_width="max-content"
            height={47}
            transparent
          />
        </div>
        <div className={cn.jobsAllBreadcrumb}>
          <FontAwesomeIcon icon={faChevronRight} />
          <div className={cn.marginBreadcrumb}>Batch Definition</div>
        </div>
        <div className={cn.flexGrow} />
      </div>
    </>
  );
};
